export default {
  name: 'time-to-go',
  props: {
    datetime: {
      type: String,
      required: true,
    },
  },
  computed: {
    date() {
      return new Date(this.datetime);
    },
    displayDate() {
      if (new Date().getTime() >= Date.parse(this.date)) {
        return this.$t('expired');
      }
      return this.$d(this.date, 'long');
    },
  },
  render(h) {
    return h(
      'time',
      {
        datetime: this.date,
        title: this.datetime,
      },
      this.displayDate,
    );
  },
  i18n: {
    messages: {
      de: {
        expired: 'Abgelaufen',
      },
    },
  },
};



// WEBPACK FOOTER //
// ./components/TimeToGo.js